/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@mui/material";
import { InformacionCitasProximas, InformacionCitasAnteriores } from "store/tav/tavActions";
import { useState } from "react";
import _ from "lodash";
import { store } from "store/store";
function FormBusqueda({ onSearch, onClickNueva }) {
  const { solicitudes } = useSelector((state) => state.solicitud);
  const dispatch = useDispatch();

  const [cmboPaciente, setcmboPaciente] = useState(null);

  const onChangeCitas = (idSolicitud) => {
    // Prepara los datos de búsqueda
    const filtros = {
      idSolicitud: idSolicitud,
    };

    onSearch(filtros);
  };
  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const agendareliminarPacienteMedicoSoliciud = _.filter(usuarioPermisos, { idPermiso: 30 });
  const agendareliminarPacienteMedicoExpediente = _.filter(usuarioPermisos, { idPermiso: 77 });

  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12} md={12} lg={12}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="center">
                <Autocomplete
                  options={solicitudes}
                  getOptionLabel={(option) => option.precandidato}
                  id="controlled-demo"
                  value={cmboPaciente}
                  onChange={(event, newValue) => {
                    setcmboPaciente(newValue);
                    if (newValue != null) {
                      onChangeCitas(newValue.idSolicitud);
                      InformacionCitasProximas(dispatch, 63, newValue.idSolicitud);
                      InformacionCitasAnteriores(dispatch, 63, newValue.idSolicitud);
                    } else {
                      onChangeCitas(0);
                      InformacionCitasProximas(dispatch, 63, 0);
                      InformacionCitasAnteriores(dispatch, 63, 0);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={"Paciente"} variant="outlined" error={false} />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="left">
                {agendareliminarPacienteMedicoSoliciud.length > 0 ||
                agendareliminarPacienteMedicoExpediente.length > 0 ? (
                  <Button
                    variant="contained"
                    startIcon={<Icon>add</Icon>}
                    onClick={onClickNueva}
                    size="small"
                    color="primary"
                  >
                    Nueva cita
                  </Button>
                ) : null}
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default FormBusqueda;
